export default [
	{
		featureType: 'water' as 'water',
		elementType: 'geometry' as 'geometry',
		stylers: [
			{
				color: '#e9e9e9',
			},
			{
				lightness: 17,
			},
		],
	},
	{
		featureType: 'landscape' as 'landscape',
		elementType: 'geometry' as 'geometry',
		stylers: [
			{
				color: '#f5f5f5',
			},
			{
				lightness: 20,
			},
		],
	},
	{
		featureType: 'road.highway' as 'road.highway',
		elementType: 'geometry.fill' as 'geometry.fill',
		stylers: [
			{
				color: '#ffffff',
			},
			{
				lightness: 17,
			},
		],
	},
	{
		featureType: 'road.highway' as 'road.highway',
		elementType: 'geometry.stroke' as 'geometry.stroke',
		stylers: [
			{
				color: '#ffffff',
			},
			{
				lightness: 29,
			},
			{
				weight: 0.2,
			},
		],
	},
	{
		featureType: 'road.arterial' as 'road.arterial',
		elementType: 'geometry' as 'geometry',
		stylers: [
			{
				color: '#ffffff',
			},
			{
				lightness: 18,
			},
		],
	},
	{
		featureType: 'road.local' as 'road.local',
		elementType: 'geometry' as 'geometry',
		stylers: [
			{
				color: '#ffffff',
			},
			{
				lightness: 16,
			},
		],
	},
	{
		featureType: 'poi' as 'poi',
		elementType: 'geometry' as 'geometry',
		stylers: [
			{
				color: '#f5f5f5',
			},
			{
				lightness: 21,
			},
		],
	},
	{
		featureType: 'poi.park' as 'poi.park',
		elementType: 'geometry' as 'geometry',
		stylers: [
			{
				color: '#dedede',
			},
			{
				lightness: 21,
			},
		],
	},
	{
		elementType: 'labels.text.stroke' as 'labels.text.stroke',
		stylers: [
			{
				visibility: 'on',
			},
			{
				color: '#ffffff',
			},
			{
				lightness: 16,
			},
		],
	},
	{
		elementType: 'labels.text.fill' as 'labels.text.fill',
		stylers: [
			{
				saturation: 36,
			},
			{
				color: '#333333',
			},
			{
				lightness: 40,
			},
		],
	},
	{
		elementType: 'labels.icon' as 'labels.icon',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'transit' as 'transit',
		elementType: 'geometry' as 'geometry',
		stylers: [
			{
				color: '#f2f2f2',
			},
			{
				lightness: 19,
			},
		],
	},
	{
		featureType: 'administrative' as 'administrative',
		elementType: 'geometry.fill' as 'geometry.fill',
		stylers: [
			{
				color: '#fefefe',
			},
			{
				lightness: 20,
			},
		],
	},
	{
		featureType: 'administrative' as 'administrative',
		elementType: 'geometry.stroke' as 'geometry.stroke',
		stylers: [
			{
				color: '#fefefe',
			},
			{
				lightness: 17,
			},
			{
				weight: 1.2,
			},
		],
	},
];
